import Image from "next/image";
import Link from "next/link";
import React from "react";

const ShowAllButton = ({ title, url, styles }) => {
  return (
    <Link
      title={title}
      href={url}
      prefetch={false}
      className={`items-center gap-2.5 justify-between sm:py-4 py-3 px-6 rounded-lg sm:rounded-[50px] text-themeBlack text-opacity-50 border border-themeBlack border-opacity-50 transition-all ease-in-out duration-200 hover:bg-themeblackColor hover:!border-transparent hover:bg-opacity-50 hover:text-white ${styles ? styles : ""}`}
    >
      <span className="text-xs font-medium leading-normal">
        Tümünü Görüntüleyin
      </span>
      <div className="relative w-3.5 h-1.5">
        <Image
          src="/icons/right.svg"
          alt="right"
          fill
          className="object-cover"
        />
      </div>
    </Link>
  );
};

export default ShowAllButton;
